"use client";

import { Button, Icon, Typography } from "@kyan/ui";
import { useRouter } from "next/navigation";

import { LoadingGem } from "#/components/LoadingGem/LoadingGem";
import { routes } from "#/config/routes";

interface ErrorPageProps {
  error: Error & { digest?: string };
  reset: () => void;
}

const ErrorPage = ({ error, reset }: ErrorPageProps) => {
  const router = useRouter();

  console.error(error);

  return (
    <main className="-mt-20 flex min-h-screen items-center justify-center p-6">
      <div className="flex flex-col items-center gap-4">
        <LoadingGem className="mb-8 size-40" />

        <Typography bold grotesk primary element="h2">
          Oops, something went wrong
        </Typography>

        <Button
          variant="link"
          className="text-textSecondary hover:text-textPrimary flex items-center gap-2 text-xs"
          onClick={() => {
            reset();
          }}
        >
          <Typography size={12}>Reload the page or try again later.</Typography>
          <Icon size="xs" name="reload" />
        </Button>

        <Button
          size="lg"
          className="w-46 text-[15px]"
          onClick={() => {
            router.push(routes.options());
          }}
        >
          Go back to Home
        </Button>
      </div>
    </main>
  );
};

export default ErrorPage;
